// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"618":"74a51f70","995":"74a51f70"}[chunkId] + ".chunk.css";
};